import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card operations" }
const _hoisted_2 = { class: "card-header pb-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-header pt-0" }
const _hoisted_5 = { class: "text-500" }
const _hoisted_6 = { class: "grid mt-2" }
const _hoisted_7 = { class: "col-7 pb-0" }
const _hoisted_8 = { class: "col-4 pb-0" }
const _hoisted_9 = { class: "grid align-items-center" }
const _hoisted_10 = { class: "col-7 pb-0" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "col-4 pb-0" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "col-1 pb-0 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t('max_clicks_by_subids_uuids')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('max_clicks_by_subids_uuids_help')), 1)
    ]),
    (_ctx.maxClicksBySubids.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('subid_uuid')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('max_clicks')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxClicksBySubids, (maxClicksBySubid, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "insights mt-2 mb-0 px-2 py-2",
              key: index
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FieldText, {
                      modelValue: maxClicksBySubid.key,
                      "onUpdate:modelValue": ($event: any) => ((maxClicksBySubid.key) = $event),
                      modelModifiers: { trim: true },
                      style: {"margin-bottom":"0 !important"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_FieldNumber, {
                      class: "mb-0",
                      modelValue: maxClicksBySubid.value,
                      "onUpdate:modelValue": ($event: any) => ((maxClicksBySubid.value) = $event),
                      modelModifiers: { number: true },
                      min: 0,
                      step: 1,
                      label: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createVNode(_component_IconPark, {
                    class: "cursor-pointer text-pink-600",
                    type: "delete",
                    theme: "outline",
                    size: "16",
                    onClick: ($event: any) => (_ctx.deleteMaxClicksBySubid(index))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('delete'),
                      void 0,
                      { right: true }
                    ]
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_PrimeVueButton, {
      class: "p-button-success p-button-outlined w-full mt-3",
      icon: "pi pi-plus",
      onClick: _ctx.addMaxClicksBySubid
    }, null, 8, ["onClick"])
  ]))
}